import downArrow from '../static/down-arrow.png';
import rightArrow from '../static/rightIcon.png';
import leftArrow from '../static/leftIcon.png';
import screenImage from '../static/background2.png';
import playstore from '../static/playstore.png';
import appstore from '../static/appstore.png';
import turnDevice from '../static/turnDevice.jpeg';
import storefront from '../static/aboutStory.jpg';

import fullScreenIcon from '../static/full-screen-arrow-icon.svg';
import chevronRight from '../static/chevron-right.svg';
import downlaodIcon from '../static/download-file.svg';
import externalLink from '../static/externalLink.svg';
import partyHatIcon from '../static/party-hat.svg';
import importIcon from '../static/import-icon.svg';
import heartIcon from '../static/heart-icon.svg';
import ledIcon from '../static/ledIcon.png';
import ledIcon1 from '../static/ledIcon-1.png';
import gameBanner from '../static/game_banner.png';
import applicationIcon from '../static/applicationIcon.png';
import commingSoon from '../static/commingSoon.jpg';
// import emojiAppVideo from '../static/emojiAppVideo.mp4';
import development from '../static/icons8-settings-150.svg';
import blog1Listing from '../static/blogs/blog 1 listing image.png';
import blog1Detail from '../static/blogs/blog 1 detail page image.png';
import blog2Listing from '../static/blogs/blog 2 listing image.jpg';
import blog2Detail from '../static/blogs/blog 2 detail page image.jpg';
import blog3Listing from '../static/blogs/blog 3 listing image.png';
import blog3Detail from '../static/blogs/blog 3 detail page image.jpg';
import blog4Listing from '../static/blogs/blog_4_listing_image.jpg';
import blog4Detail from '../static/blogs/blog_4_detail_page_image.jpg';
import blog5Listing from '../static/blogs/blog_5_listing_image.png';
import blog5Detail from '../static/blogs/blog_5_detail_page_image.png';
import blog6Listing from '../static/blogs/blog_6_listing_image.png';
import blog6Detail from '../static/blogs/blog_6_detail_page_image.png';

export const images = {
    downArrow,
    turnDevice,
    downlaodIcon,
    leftArrow,
    rightArrow,
    screenImage,
    playstore,
    appstore,
    chevronRight,
    fullScreenIcon,
    externalLink,
    partyHatIcon,
    importIcon,
    heartIcon,
    ledIcon,
    ledIcon1,
    applicationIcon,
    commingSoon,
    // emojiAppVideo,
    development,
    blog1Listing,
    blog1Detail,
    blog2Listing,
    blog2Detail,
    blog3Listing,
    blog3Detail,
    blog4Listing,
    blog4Detail,
    blog5Listing,
    blog5Detail,
    blog6Listing,
    blog6Detail,
    storefront,
    gameBanner
}

export const THEME_COLOR = '#635ee7';
export const THEME_BG_COLOR = '#1a1b1f';
export const THEME_BG_LIGHT_COLOR = '#ffffff0d';

export const GOOGLE_ADS_CLIENT = 'ca-pub-1129001917462108';

export const TAKEWIDGET_PROPERTY_ID = '68e24634d59487194ef37545';
export const TAKEWIDGET_PAGE_ID = '1j6pu4fnn';